import {MethodDatePickerInterface, Utilities} from './utilities.model';
import {FormControl} from '@angular/forms';
import {DatePipe} from '@angular/common';

declare const require: any;
const moment: any = require('moment');
moment.locale('it');

export class DateUtilities {
	static onlyDate: string = 'L'; // es per l'italia DD/MM/AAAA
	static onlyTime: string = 'LTS'; // es per l'italia hh:mm:ss
	static dateAndTime: string = 'L LTS'; // es per l'italia hh:mm:ss

	static today: Date = new Date(new Date().setHours(0, 0, 0, 0));
	static todayMorning: Date = new Date(new Date().setHours(7, 0, 0));
	static todayAfternoon: Date = new Date(new Date().setHours(12, 0, 0, 0));
	static todayEvening: Date = new Date(new Date().setHours(16, 0, 0, 0));
	static todayEveningMax: Date = new Date(new Date().setHours(18, 59, 59, 0));
	static olderDate: string = '01/01/1990 00:00:00';
	static olderUtcDate: string = DateUtilities.getUTCStringFromDate(new Date(1900, 1, 1, 0, 0, 0));
	static newerUtcDate: string = DateUtilities.getUTCStringFromDate(new Date(2099, 12, 31, 23, 59, 59));

	static dateTimePipeFormatHHmmss = 'dd/MM/yyyy HH:mm:ss';
	static datePipeFormatHHmmss = 'HH:mm:ss';
	static datePipeTimezone = 'GMT+00:00';
	static datePipeLocaleIT = 'it-IT';

	static dateISO8601 = 'YYYY-MM-DD';

	static DATE_ISO8601_FORMAT = {
		'format': 'YYYY-MM-DD',
		'european': 'DD/MM/YYYY',
		'LITTLE_ENDIAN': {
			'-': 'dd-MM-yyyy',
			'/': 'dd/MM/yyyy',
		},
		'MIDDLE_ENDIAN': {
			'-': 'MM-dd-yyyy',
			'/': 'MM/dd/yyyy',
		},
		'BIG_ENDIAN': {
			'-': 'yyyy-MM-dd',
			'/': 'yyyy/MM/dd',
		},
	};

	static DATETIME_ISO8601_FORMAT = {
		'FORMAT': 'YYYY-MM-DDTHH:mm:ss',
		'FORMAT_EXTENDED': 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
		'LITTLE_ENDIAN': {
			'-': 'dd-MM-yyyy HH:mm:ss',
			'/': 'dd/MM/yyyy HH:mm:ss',
		},
		'MIDDLE_ENDIAN': {
			'-': 'MM-dd-yyyy HH:mm:ss',
			'/': 'MM/dd/yyyy HH:mm:ss',
		},
		'BIG_ENDIAN': {
			'-': 'yyyy-MM-dd HH:mm:ss',
			'/': 'yyyy/MM/dd HH:mm:ss',
		},
	};

	private static IT_MONTH_NAMES: { [key: string]: string[] } = {
		'long': 'Gennaio_Febbraio_Marzo_Aprile_Maggio_Giugno_Luglio_Agosto_Settembre_Ottobre_Novembre_Dicembre'.split('_'),
		'short': 'Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic'.split('_'),
		'narrow': 'G_F_M_A_M_G_L_A_S_O_N_D'.split('_')
	};

	private static IT_DAY_OF_WEEK_NAMES: { [key: string]: string[] } = {
		'long': 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
		'short': 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
		'narrow': 'D_L_M_M_G_V_S'.split('_')
	};

	private static IT_FIRST_DAY_OF_WEEK: number = 1;

	static getDateNow(): string {
		const date_now: Date = new Date();
		return moment(date_now).format(this.onlyDate) + ' ' + moment(date_now).format(this.onlyTime);
	}

	static getNow(): Date {
		return new Date();
	}

	static isMoment(value: any): boolean {
		return moment.isMoment(value);
	}

	static getDateWithoutTimes(date: string): string {
		if (!Utilities.isVoid(date)) {
			if (date.indexOf(' ') > 0) {
				return date.substring(0, date.indexOf(' '));
			} else {
				return date;
			}
		} else {
			return '';
		}
	}

	static getDateUTCFromString(d: any): Date {
		if (!Utilities.isVoid(d)) {
			return new Date(moment(d).utc());
		}
		return null;
	}

	static getDate(d: any): Date {
		if (!Utilities.isVoid(d)) {
			return new Date(moment(d));
		}
		return null;
	}

	static getMomentUTC(d: any): any {
		return moment(d).utc();
	}

	static getMoment(d: any): any {
		return moment(d);
	}

	static getIsoStringFromDate(d: any): Date {
		if (!Utilities.isVoid(d)) {
			return moment.utc(d).format('YYYY-MM-DDTHH:mm:ss[Z]');
		}
		return null;
	}

	static getStringDateFromDate(d: any, pattern: string = 'YYYY-MM-DD'): string {
		if (!Utilities.isEmpty(d)) {
			return moment(d).format(pattern);
		}
		return null;
	}

	static getStringDateAndHourFromDate(d: any): string {
		if (!Utilities.isVoid(d)) {
			return moment(d).format('DD/MM/YYYY HH:mm');
		}
		return null;
	}

	static getDayFromUTC(d: any): string {
		if (!Utilities.isVoid(d)) {
			return moment(d).format('DD/MM/YYYY');
		}
		return null;
	}

	static getUTCStringFromDate(d: any): string | null {
		if (!Utilities.isVoid(d) && moment(d).isValid()) {
			return moment.utc(d).format('YYYY-MM-DDTHH:mm:ssZZ');
		}
		return null;
	}

    static getUTCStringFromDateWithForm(d: any, format: any): string | null {

        if (!Utilities.isVoid(d) && !Utilities.isVoid(format) && moment(d, format, true).isValid()) {

            return moment.utc(d, format, true).format('YYYY-MM-DDTHH:mm:ssZZ');

        }

        return null;

    }

	static getUTCFromDateWithForm(d: any, format: any): string | null {
		if (!Utilities.isVoid(d) && !Utilities.isVoid(format) && moment(d, format, true).isValid()) {

			return moment(d, format, true).format('YYYY-MM-DDTHH:mm:ss[Z]');
		}
		return null;
	}

	static compareDateIsAfter(d1: Date | string, d2: Date | string): boolean {
		if (!Utilities.isVoid(d1) && !Utilities.isVoid(d2)) {
			if (typeof d1 === 'string') {
				d1 = moment(d1, 'L, LTS');
			}
			if (typeof d2 === 'string') {
				d2 = moment(d2, 'L, LTS');
			}
			return moment(d1).isAfter(d2);
		}
		return false;
	}

	static compareDateIsBefore(d1: Date, d2: Date): boolean {
		if (!Utilities.isVoid(d1) && !Utilities.isVoid(d2)) {
			return moment(d1).isBefore(d2);
		}
		return false;
	}

	static compareDateIsSame(d1: Date, d2: Date): boolean {
		if (!Utilities.isVoid(d1) && !Utilities.isVoid(d2)) {
			return moment(d1).isSame(d2);
		}
		return false;
	}

	static isValid(d: any): boolean {
		if (!Utilities.isVoid(d)) {
			return moment(d).isValid();
		}
	}

	static getDateFromString(d: string, mFormat?: string): Date | null {
		let date: Date = null;
		if (!Utilities.isVoid(d) && d.length > 0) {
			if (Utilities.isVoid(mFormat)) {
				mFormat = 'L LTS';
			}
			date = new Date(moment(DateUtilities.getDateWithoutTimes(d), mFormat));
			if (moment(date, mFormat, true).isValid()) {
				return date;
			}
		}
		return date;
	}

	static convertUtcDate(date: string, mFormat?: string): string {
		if (!Utilities.isVoid(date)) {
			if (Utilities.isVoid(mFormat)) {
				mFormat = 'L LTS';
			}
			if (moment(date).isValid()) {
				return moment(date).utc().format(mFormat);
			}
		}
		return '';
	}

	static convertDate(date: string, mFormat?: string): string {
		if (!Utilities.isVoid(date)) {
			if (Utilities.isVoid(mFormat)) {
				mFormat = 'L LTS';
			}
			if (moment(date).isValid()) {
				return moment(date).format(mFormat);
			}
		}
		return '';
	}

	static convertDateFromCustomFormat(date: string, customFormat: string, mFormat?: string): string {
		if (!Utilities.isVoid(date)) {
			if (Utilities.isVoid(mFormat)) {
				mFormat = 'L LTS';
			}
			if (moment(date, customFormat).isValid()) {
				return moment(date, customFormat).format(mFormat);
			}
		}
		return '';
	}

	static getStringFromDate(date: any, mFormat?: string): string {
		if (!Utilities.isVoid(date)) {
			const d: Date = DateUtilities.getDate(date);
			if (Utilities.isVoid(mFormat)) {
				mFormat = 'L LTS';
			}
			const res: any = moment(d.setHours(0, 0, 0, 0)).format(mFormat);
			if (moment(res, mFormat).isValid()) {
				return res;
			}
		}
		return null;
	}

	static getStringFromMoment(date: any, mFormat?: string): string {
		if (!Utilities.isVoid(date)) {
			if (Utilities.isVoid(mFormat)) {
				mFormat = 'L LTS';
			}
			const res: any = moment(date).format(mFormat);
			if (moment(res, mFormat).isValid()) {
				return res;
			}
		}
		return null;
	}

	static mergeTimeInDateForm(date: FormControl, time: FormControl): string {
		return moment(date.value).set({
			'hour': moment(time.value).get('hour'),
			'minute': moment(time.value).get('minute')
		}).format();
	}

	static getDiffBetweenTwoDates(d1: any, d2: any): number {
		const date: any = moment(d1);
		return date.diff(d2, 'days');
	}


	static validatorDatePicker(md2Datepicker: any, mInterface: MethodDatePickerInterface, obj?: any): void {
		// md2Datepicker._handleBlur = function (event) {
		// 	md2Datepicker._inputFocused = false;
		// 	if (!md2Datepicker.opened) {
		// 		md2Datepicker._onTouched();
		// 	}
		// 	const value = (<HTMLTextAreaElement>event.target).value;
		// 	if (value) {
		// 		let isValid = moment(value, 'L', true).isValid();
		// 		if (isValid) {
		// 			md2Datepicker.value = moment(value, 'L');
		// 			md2Datepicker._emitChangeEvent();
		// 			if (!Utilities.isVoid(md2Datepicker.max) && !moment(md2Datepicker.value, 'L').isSame(md2Datepicker.max, 'L') && moment(md2Datepicker.value).isAfter(md2Datepicker.max)) {
		// 				isValid = false;
		// 				mInterface.setErrorMaxValidator(obj);
		// 				//controls.setErrors({max_validator: true});
		// 			}
		// 			if (!Utilities.isVoid(md2Datepicker.min) && !moment(value, 'L').isSame(md2Datepicker.min, 'L') && moment(value, 'L').isBefore(md2Datepicker.min)) {
		// 				isValid = false;
		// 				mInterface.setErrorMinValidator(obj);
		// 				//controls.setErrors({min_validator: true});
		// 			}
		// 			if (isValid) {
		// 				mInterface.clearValidators(obj);
		// 				//controls.clearValidators();
		// 			}
		// 		} else {
		// 			if (Utilities.isVoid(md2Datepicker.value)) {
		// 				(<HTMLTextAreaElement>event.target).value = null;
		// 				md2Datepicker.writeValue(null);
		// 			} else {
		// 				mInterface.setErrorDateValidator(obj);
		// 				//controls.setErrors({date_validator: true});
		// 			}
		// 		}
		// 	} else {
		// 		md2Datepicker.value = null;
		// 		(<HTMLTextAreaElement>event.target).value = null;
		// 		md2Datepicker.writeValue(null);
		// 		md2Datepicker._emitChangeEvent();
		// 		mInterface.clearValidators(obj);
		// 		//controls.clearValidators();
		// 	}
		// 	mInterface.doSameThing();
		// };
	}

	static setMomentLocale(): void {
		moment.locale('it');
		moment.updateLocale('it', {
			relativeTime: {
				future: '%s',
				s: function (number: any, withoutSuffix: any, key: any, isFuture: any) {
					return 'alcuni secondi';
				},
			}
		});
	}


	static getTimeFromUtcDate(date: any): { h: string, m: string, s: string } {
		if (!!date) {
			const pipe: DatePipe = new DatePipe(moment.locale());
			const parsedDate: string = pipe.transform(date, this.datePipeFormatHHmmss, this.datePipeTimezone, this.datePipeLocaleIT);
			return {
				h: parsedDate.split(':')[0],
				m: parsedDate.split(':')[1],
				s: parsedDate.split(':')[2]
			};
		}
		return null;
	}

	static getTimeFromDate(date: any): { h: string, m: string, s: string } {
		if (!!date) {
			const parsedDate: string = moment(date).format(this.datePipeFormatHHmmss);
			return {
				h: parsedDate.split(':')[0],
				m: parsedDate.split(':')[1],
				s: parsedDate.split(':')[2]
			};
		}
		return null;
	}

	static getTimeFromItalianDate(date: any): { h: string, m: string, s: string } {
		if (!!date) {
			const pipe: DatePipe = new DatePipe(moment.locale());
			const parsedDate: string = pipe.transform(date, this.datePipeFormatHHmmss);
			return {
				h: parsedDate.split(':')[0],
				m: parsedDate.split(':')[1],
				s: parsedDate.split(':')[2]
			};
		}
		return null;
	}


	static getDateFromUtcDate(date: any,format: string): string {
    if (!!date) {
			if(!format){
            format = this.dateTimePipeFormatHHmmss;
        }
        const pipe: DatePipe = new DatePipe(moment.locale());
		let dateResult =  pipe.transform(date * 1000, format, 'Europe/Rome', this.datePipeLocaleIT);
        return dateResult;
    }
    return null;
}


	static getCustomIsoDateFromDate(date: any): string {
		let resultDate: Date;
		if (date){
			resultDate = new Date(date)
			return resultDate.toISOString();
		}
		else{
			return null;
		}
	}

	static getItalianDateFromUtcDate(date: any ): string {
		if (!!date) {
			let italianDate = new Date(date.slice(0, -1));
			var offset = new Date(date).getTimezoneOffset();
			// if offset equals -60 then the time zone offset is UTC+01
			// if offset equals -120 then the time zone offset is UTC+2
			if(offset == -60){			
				italianDate.setTime(italianDate.getTime() + (1*60*60*1000));
				return moment(italianDate);
			}
			else{
				italianDate.setTime(italianDate.getTime() + (2*60*60*1000));
				return moment(italianDate);
			}
			
			
		}
		return null;

	}

	static getDateCustomFormat(date: number, format?: string ): string {
		if (!!date) {
			let dateCustom = new Date(date * 1000);
			const frmtDate = Utilities.isEmpty(format) ? 'DD/MM/YYYY' : format;
			return moment(dateCustom).format(frmtDate);				
		}
		return null;
	}


	static getGMTFormatDateFromString(date: any): string {
		if (!!date) {
			const pipe: DatePipe = new DatePipe(moment.locale());
			let dateStringGMTFormat =  pipe.transform(date, 'yyyy-MM-ddTHH:mm:ss', this.datePipeTimezone,  this.datePipeLocaleIT);
			return dateStringGMTFormat;
		}
		return null;

	}


	static setDateLocale(dateLocale: any, locale: string): void {
		/*if (locale === 'en') {
			moment.locale('en');
			return;
		}
		dateLocale.months = DateUtilities.IT_MONTH_NAMES;
		dateLocale.daysOfWeek = DateUtilities.IT_DAY_OF_WEEK_NAMES;
		dateLocale.firstDayOfWeek = DateUtilities.IT_FIRST_DAY_OF_WEEK;

		moment.updateLocale('it', {
			relativeTime : {
				future: '%s',
				s: function (number, withoutSuffix, key, isFuture){
					return 'alcuni secondi';
				},
			}
		});

		// moment.fn.fromNowOrNow = function (a) {
		// 	if (Math.abs(moment().diff(this)) < 1000) { // 1000 milliseconds
		// 		return 'just now';
		// 	}
		// 	return this.fromNow(a);
		// }*/
	}

	/**
	 * return end_date for calendar component
	 * @param start_date
	 */
	static getEndDateIntervalForCalendarFromStartDate(start_date: string): string {
		let end_date: string;
		const
			day: number = Number.parseInt(start_date.split('-')[2]),
			parsedMonth: number = Number.parseInt(start_date.split('-')[1]),
			parsedYear: number = Number.parseInt(start_date.split('-')[0]);

		switch (true) {
			case day === 1 && parsedMonth === 1:
			case day === 1 && parsedMonth === 3:
			case day === 1 && parsedMonth === 5:
			case day === 1 && parsedMonth === 7:
			case day === 1 && parsedMonth === 8:
			case day === 1 && parsedMonth === 10:
			case day === 1 && parsedMonth === 12:
				end_date = `${parsedYear}-${parsedMonth}-31`;
				break;
			case day === 1 && parsedMonth === 2:
				end_date = `${parsedYear}-${parsedMonth}-28`;
				break;
			case day === 1 && parsedMonth === 4:
			case day === 1 && parsedMonth === 6:
			case day === 1 && parsedMonth === 9:
			case day === 1 && parsedMonth === 11:
				end_date = `${parsedYear}-${parsedMonth}-30`;
				break;
			case day === 30 && parsedMonth === 1:
				end_date = `${parsedYear}-3-1`;
				break;
			case day === 31 && parsedMonth === 1:
				end_date = `${parsedYear}-3-2`;
				break;
			case day === 29 && parsedMonth === 2:
				end_date = `${parsedYear}-3-28`;
				break;
			default:
				end_date = `${parsedMonth !== 12 ? parsedYear : (parsedYear + 1)}-${parsedMonth !== 12 ? (parsedMonth + 1) : 1}-${day - 1}`;
				break;
		}
		return end_date;
	}

	static getDifferenceBetweenToDate(date_1: Date | string, date_2: Date | string): { days: number, hours: number, minutes: number, seconds: number } {

		let date_time1: number, date_time2: number;

		date_time1 = !date_1 ? new Date().getTime() : typeof date_1 === 'string' ? new Date(date_1).getTime() : date_1.getTime();
		date_time2 = !date_2 ? new Date().getTime() : typeof date_2 === 'string' ? new Date(date_2).getTime() : date_2.getTime();

		const
			cSeconds: number = 1000,
			cMinutes: number = cSeconds * 60,
			cHours: number = cMinutes * 60,
			cDays: number = cHours * 24;

		const
			diff: number = date_time1 - date_time2,

			d: number = Number.parseInt((diff / cDays).toString()),
			dDiff: number = (((diff / cDays) - d) * cDays),

			h: number = Number.parseInt((dDiff / cHours).toString()),
			hDiff: number = (((dDiff / cHours) - h) * cHours),

			m: number = Number.parseInt((hDiff / cMinutes).toString()),
			mDiff: number = (((hDiff / cMinutes) - m) * cMinutes),

			s: number = Number.parseInt((mDiff / cSeconds).toString());

		return {days: d, hours: h, minutes: m, seconds: s};
	}

	static getStringDateAndHourFromDateParseZone(d: any): string {
		if (!Utilities.isVoid(d)) {
			return moment.parseZone(d).local().format('DD/MM/YYYY HH:mm');
		}
		return null;
	}

	static getHoursArray(): string[] {
		return Array.from({ length: 24 }, (_, i) => i < 10 ? '0' + i : '' + i);
	}

	static getMinutesArray(): string[] {
		return Array.from({ length: 60 }, (_, i) => i < 10 ? '0' + i : '' + i);
	}
	
}
